import styled from 'styled-components'

export const StContainer = styled.div`
  background-color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
  width: 100%;
  display: flex;
`
